/* One history step per open overlay. Ordinary menu disclosures stay native. */
(() => {
  const key = 'kpOverlay';
  const session = `${Date.now()}-${Math.random()}`;
  const entries = new Map();
  let active = null;
  let returning = false;
  let afterReturn = null;
  const marker = () => history.state?.[key];
  const ownsEntry = () => marker()?.session === session;
  const cleanState = () => {
    const state = { ...history.state };
    delete state[key];
    return state;
  };

  window.KpOverlayHistory = {
    open(id, controls) {
      entries.set(id, controls);
      if (returning) {
        afterReturn = controls.show;
        return false;
      }
      if (active === id) return true;
      const previous = active;
      active = null;
      if (previous) entries.get(previous)?.hide();
      if (!ownsEntry() || marker().id !== id) {
        const state = { ...cleanState(), [key]: { session, id } };
        history[ownsEntry() ? 'replaceState' : 'pushState'](state, '', location.href);
      }
      active = id;
      return true;
    },
    closed(id) {
      if (active !== id) return;
      active = null;
      if (ownsEntry() && marker().id === id) {
        returning = true;
        history.back();
      }
    },
  };

  window.addEventListener('popstate', () => {
    const next = ownsEntry() ? marker().id : null;
    if (active && active !== next) {
      const previous = active;
      active = null;
      entries.get(previous)?.hide();
    }
    if (returning) {
      returning = false;
      const callback = afterReturn;
      afterReturn = null;
      if (callback) { callback(); return; }
    }
    if (next && next !== active) entries.get(next)?.show();
  });

  // Consume the menu entry before following a link, so Back from the destination
  // returns to the original page once, without reopening a stale drawer.
  document.addEventListener('click', (event) => {
    if (!active || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const controls = entries.get(active);
    const link = event.target.closest('a[href]');
    if (!link || !controls?.root?.contains(link) || link.hasAttribute('download') ||
        (link.target && link.target !== '_self')) return;
    const url = new URL(link.href, location.href);
    if (!/^https?:$/.test(url.protocol)) return;
    event.preventDefault();
    let navigated = false;
    const navigate = () => {
      if (navigated) return;
      navigated = true;
      afterReturn = null;
      location.assign(url.href);
    };
    afterReturn = navigate;
    controls.hide();
    setTimeout(navigate, 250);
  });

  // A full reload has no open overlay; discard its old document's marker.
  if (marker()) history.replaceState(cleanState(), '', location.href);
})();
